import { ISetCustomerData } from "@interfaces";
import ftApiClient from "./ftApiClient";

// Always use ftApiClient which automatically adds Authorization header if user is logged in.
// This ensures authenticated users get their redeemers even when sessionId is present in URL.
export const redeemerApi = {
    getUserRedeemers: () => {
        return ftApiClient.get("cart/redeemers/user");
    },
    updateRedeemerBookNow: (params: ISetCustomerData[], sessionId?: string) => {
        const url = sessionId ? `cart/redeemers?sessionId=${sessionId}` : "cart/redeemers";
        return ftApiClient.put(url, params);
    },
    getRedeemerBookNow: (sessionId?: string) => {
        const url = sessionId ? `cart/redeemers?sessionId=${sessionId}` : "cart/redeemers";
        return ftApiClient.get(url);
    },
    AddRedeemerBookNow: (params: ISetCustomerData, sessionId?: string) => {
        const url = sessionId ? `cart/redeemers?sessionId=${sessionId}` : "cart/redeemers";
        return ftApiClient.post(url, params);
    },
    updateRedeemer: (params: ISetCustomerData[]) => {
        const url = "cart/redeemers";
        return ftApiClient.put(url, params);
    },
    getRedeemer: (sessionId?: string) => {
        const url = sessionId ? `cart/redeemers?sessionId=${sessionId}` : "cart/redeemers";
        return ftApiClient.get(url);
    },
    AddRedeemer: (params: ISetCustomerData, sessionId?: string) => {
        const url = sessionId ? `cart/redeemers?sessionId=${sessionId}` : "cart/redeemers";
        return ftApiClient.post(url, params);
    },
};
